export default __webpack_public_path__ + "static/media/ic-timer.d910ac0d.svg";